module.exports = __webpack_public_path__ + "img/selsam.150ec254.png";